<template>
  <section class="page-section page-section--welcome pt-5">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10">
          <h1 class="display-4 text-center pb-7"> Beste <br> {{ store.name}} </h1>
        </div>

      </div>
    </div>
  </section>


  <section class="page-section page-section--welcome mt-5 bg-light-brown py-5 text-center fw-bold">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10">

          <p>Leuk dat je er was!</p>

          <p> Vergeet niet je veiling items mee te nemen / af te rekenen. </p>

          <p> Dit is niet verplicht, maar donaties zijn zeer welkom </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { visitor } from '../../stores/visitor';

export default {
  setup() {
    const store = visitor()

    return {
      store,
    }
  },
}
</script>
